// extracted by mini-css-extract-plugin
module.exports = {"LoadError":"bem_a bgu_pw bgu_a bgu_w bgu_j bgu_q","LoadError__icon":"bem_b bgu_uf bgu_fg bgu_rq","LoadError__message":"bem_c bgu_fg bgu_sl"};